// extracted by mini-css-extract-plugin
export default {"tabContainer":"cSXfbKrhXfd6jeglBsMP","tab":"dc1anOPsIL7gbszhRjfr"};